import { Collapse, Menu } from "@mui/material";
import {
  buttonBaseClasses,
  collapseClasses,
  formControlLabelClasses,
  paperClasses,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { colors } from "@zapalacorp/tokens";

export const FilterByOptionsMenu = styled(Menu)(() => ({
  [`& .${paperClasses.root}`]: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",

    borderRadius: "12px",
    minWidth: "212px",
    padding: "24px",
  },
}));

export const OptionsMenuHeader = styled("div")(() => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "space-between",

  padding: "8px 16px",
  width: "100%",

  [`& .${buttonBaseClasses.root}`]: {
    color: colors.brandBlue500,
    textAlign: "center",

    fontFamily: "Manrope",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
    letterSpacing: "0.1px",
  },
}));

export const MenuTitle = styled("span")(() => ({
  color: colors.gray700,
  fontFamily: "Manrope",
  fontSize: "18px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "28px",
}));

export const OptionsMenuBody = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
}));

interface IOptionsMenuItemContainer {
  isActive: boolean;
}

export const OptionsMenuItemContainer = styled("div", {
  shouldForwardProp: (props) => props !== "isActive",
})<IOptionsMenuItemContainer>(({ isActive }) => ({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",

  padding: "16px 0",

  "& div:nth-child(2)": {
    marginTop: isActive ? "16px" : "0",
  },
}));

export const OptionsMenuItem = styled("div")(() => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "space-between",

  cursor: "pointer",
  width: "100%",
}));

export const OptionsMenuItemTitle = styled("span")(() => ({
  color: colors.gray600,
  fontFamily: "Manrope",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "normal",
}));

export const OptionsMenuCollapse = styled(Collapse)(() => ({
  minWidth: "100% !important",
  [`& .${collapseClasses.wrapperInner}`]: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },

  [`& .${paperClasses.root}`]: {
    position: "relative",
    top: "10px",
  },

  [`& .${formControlLabelClasses.root}`]: {
    alignItems: "center",
    display: "flex",
    gap: "16px",

    color: colors.gray600,
    fontFamily: "Manrope",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
    letterSpacing: "0.5px",
    margin: "0px",
    padding: "0px",
  },
}));

const styles = makeStyles(() => ({
  textButton: {
    fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: 700,
    lineHeight: "15px",
    color: "#FFFFFF",
    fontStyle: "normal",
  },
  badgeFilter: {
    width: "18px",
    height: "18px",
    backgroundColor: "#FFFFFF",
    fontFamily: "Poppins",
    fontSize: "12px !important",
    fontWeight: 700,
    lineHeight: "18px",
    borderRadius: "20px",
    color: "#308CDB",
    paddingRight: "1px",
  },
  list: {
    paddingBottom: "16px",
  },
}));

export default styles;
